export default __webpack_public_path__ + "static/media/Actuarial.f7c7be8d.png";